import axios from "axios";
import { STATUSES } from "./apiStaus";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const email = createAsyncThunk(
  "email/fetch",
  async (_, { rejectWithValue, serializeError }) => {
    try {
      const response = await axios.get("/get_email");
      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);


const emailSlice = createSlice({
  name: "email",
  initialState: {
    emailData: {},
    emailStatus: "",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(email.pending, (state, action) => {
        state.emailStatus = STATUSES.LOADING;
      })
      .addCase(email.fulfilled, (state, action) => {
        state.emailData = action.payload;
        state.emailStatus = STATUSES.IDLE;
      })
      .addCase(email.rejected, (state, action) => {
        state.emailStatus = STATUSES.ERROR;
      });
  },
});

export default emailSlice.reducer;
